module.exports = __webpack_public_path__ + "static/img_9678-358837a73018d37bf24223e522d25b24.webp";